export default __webpack_public_path__ + "static/media/slIslandShores2.e41e02c0.jpg";